export const ERROR_OCCURRED = "ERROR_OCCURRED";
export const APP_VERSION = "APP_VERSION";


export const setAPIError = (payload: any) => ({
  type: ERROR_OCCURRED,
  payload: payload,
})
export const setAppVersion = (payload: any) => ({
  type: APP_VERSION,
  payload: payload,
})





